import { useMemo } from 'react';
import { Stack, Text } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import AirlineReferenceAccordion from '../../common/AirlineReferenceAccordion';
import { useOrderDetails } from '../../../containers/OrderDetailsContext';
import TitledCard from '../../../../../common/components/TitledCard';
import { getGroupedAirlineReferenceInfo, isCheckInAvailableToBuy } from '../../../utils';
import CheckInPromotionalBanner from './CheckInPromotionalBanner';

const NotPurchasedCheckIn = () => {
  const { t } = useTranslation();
  const { bounds, customerDetails, flightInformation, availableExtraProducts } = useOrderDetails();

  const groupedAirlineReferenceInfo = useMemo(
    () => getGroupedAirlineReferenceInfo(bounds, customerDetails, flightInformation),
    [bounds, customerDetails, flightInformation],
  );

  return (
    <Stack spacing={24}>
      {isCheckInAvailableToBuy(availableExtraProducts) && <CheckInPromotionalBanner />}
      <TitledCard data-testid="not-purchased-check-in" title={t('CheckIn.NotPurchased.Title')}>
        <Stack spacing={24}>
          <Text data-testid="not-purchased-check-in-description">
            {t('CheckIn.NotPurchased.Description')}
          </Text>
          <Stack>
            {groupedAirlineReferenceInfo.map((group, groupIndex) => (
              <AirlineReferenceAccordion
                airlineReferenceInfo={group}
                dataTestId={`not-purchased-check-in-${groupIndex + 1}`}
                key={`not-purchased-check-in-reference-accordion-${groupIndex}`}
                shouldAddBorder
              />
            ))}
          </Stack>
        </Stack>
      </TitledCard>
    </Stack>
  );
};

export default NotPurchasedCheckIn;
